"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupListStyled = void 0;
const constants_1 = require("../../theme/constants");
exports.GroupListStyled = styled.article.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  >.intro {
    align-items: center;
    padding: 2.5em;

    >.welcome {
      max-width: 45em;
      text-align: center;
    }

    >.discover {
      display: flex;
      flex-flow: column nowrap;
      gap: 0.25em;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;

      >.discover-text {
        font-size: 0.875em;
        letter-spacing: 0.025em;
      }

      >.discover-arrow {
        font-size: 1.5em;
        transform: rotateZ(90deg);
      }
    }
  }

  >.grid {
    display: grid;
    grid-gap: 1.5em 1rem;
    width: 100%;

    @media (min-width: ${constants_1.sizes.laptop}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${constants_1.sizes.laptop}) {
      grid-template-columns: repeat(1, 1fr);
    }

    >.group {
      @media (min-width: ${constants_1.sizes.laptop}) {
        grid-column: span 2;
      }

      @media (max-width: ${constants_1.sizes.laptop}) {
        grid-column: span 1;
      }
    }

    > button.octo.group {
      >.panel {
        margin-bottom: 2em;
      }
    }
  }
}
`;
//# sourceMappingURL=GroupList.styled.js.map